export const GAMMA_STAGE = 'gamma';
export const RELEASE_STAGE = 'release';

/**
 * Get base endpoint of API gateway
 */
export function getBaseEndpointForAPIGateway(env) {
  const VUE_API_ENV = process.env.VUE_APP_API_ENV || '';
  const VUE_APP_API_STYLE = process.env.VUE_APP_API_STYLE || 'proxy';
  const url = {
    proxy: {
      [GAMMA_STAGE]: '/cslp-gamma',
      [RELEASE_STAGE]: '/cslp-release'
    },
    direct: {
      [GAMMA_STAGE]: 'https://api-cslp-emt.amazon.cn/gateway-gamma',
      [RELEASE_STAGE]: 'https://api-cslp-emt.amazon.cn/gateway'
    }
  };
  if (env) return url[VUE_APP_API_STYLE][env];
  if (!VUE_API_ENV) return url[VUE_APP_API_STYLE][GAMMA_STAGE];
  return url[VUE_APP_API_STYLE][VUE_API_ENV];
}

/**
 * Get base endpoint of mini-app core services
 */
export function getBaseEndpointForMiniAppCore(env) {
  const VUE_API_ENV = process.env.VUE_APP_API_ENV || '';
  const VUE_APP_API_STYLE = process.env.VUE_APP_API_STYLE || 'proxy';
  const url = {
    proxy: {
      [GAMMA_STAGE]: '/mini-gamma',
      [RELEASE_STAGE]: '/mini-release'
    },
    direct: {
      [GAMMA_STAGE]: 'https://miniapp.amazon.cn/gamma',
      [RELEASE_STAGE]: 'https://miniapp.amazon.cn'
    }
  };
  if (env) return url[VUE_APP_API_STYLE][env];
  if (!VUE_API_ENV) return url[VUE_APP_API_STYLE][GAMMA_STAGE];
  return url[VUE_APP_API_STYLE][VUE_API_ENV];
}
